import React from "react";
import { useData } from "../../../components/firebase/DataProvider";
import Typography from "@material-ui/core/Typography";
import Countdown from "react-countdown";
import useStyle from "./style/style";

function CountdownEvent() {
  const { countdownList } = useData();

  const classes = useStyle();

  const format = (dates) => {
    var now = new Date();
    var start = new Date(dates?.valueOf());
    var diff =
      now -
      start +
      (start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000;
    var oneDay = 1000 * 60 * 60 * 24;
    var day = Math.floor(diff / oneDay);
    return day;
  };

  return (
    <div style={{ paddingTop: "10px" }}>
      <div
        className={classes.coutdownBack}
        style={{
          backgroundImage: `url("${countdownList?.background_image}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: "150px",
          display: "flex",
          justifyContent: "center",
          borderRadius: "10px",
          textAlign: "center",
          alignItems: "center",
        }}
      >
        <div>
          <Typography
            variant="body2"
            style={{ color: countdownList?.style?.text_color }}
          >
            {countdownList?.title}
          </Typography>
          {countdownList?.type_count == "down" ? (
            <Countdown
              date={countdownList?.target_date.toMillis()}
              renderer={(props) => {
                return (
                  <Typography
                    variant="h6"
                    style={{
                      color: countdownList?.style?.text_color,
                      fontWeight: "bold",
                    }}
                  >
                    {props.days} {countdownList?.text}
                  </Typography>
                );
              }}
            />
          ) : (
            <Typography
              variant="h6"
              style={{
                color: countdownList?.style?.text_color,
                fontWeight: "bold",
              }}
            >
              {format(countdownList?.target_date?.toMillis())} {countdownList?.text}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}

export default CountdownEvent;
